<sms-app-event></sms-app-event>
<div id="container">
    <router-outlet></router-outlet>
</div>
